import {
  useDeliveryInfo,
  useDeliveryPickup,
  usePickupInfo
} from '~/context/vdp/DeliveryPickupContext';

export default function useShowDeliveryUnavailableBanner(): boolean {
  const { hasError, isLoaded } = useDeliveryPickup();
  const canDeliver = Boolean(useDeliveryInfo());
  const canPickup = Boolean(usePickupInfo());

  return isLoaded && !hasError && !canDeliver && !canPickup;
}
